import { Box, Button, Modal, SubPageLayout } from "@bcc-ui/ui-components";
import { t } from "i18next";
import React from "react";

import style from "./user-settings-subpage.scss";
import {
    USER_SETTINGS_FORM_ID,
    UserSettingsForm,
} from "components/settings/views/my-settings/user-settings/user-settings-form/UserSettingsForm";

import testIds from "testIds.json";

export const UserSettingsSubpage = () => {
    const [isCancelModalVisible, setIsCancelModalVisible] = React.useState(false);
    const [formResetCount, setFormResetCount] = React.useState(0);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [isDirty, setIsDirty] = React.useState(false);

    return (
        <>
            <SubPageLayout
                key={formResetCount}
                buttons={
                    <>
                        <Button
                            variant="Primary"
                            type="submit"
                            form={USER_SETTINGS_FORM_ID}
                            isLoading={isSubmitting}
                            loadingText={t("Common.saving")}
                            disabled={!isDirty}
                            testId={testIds.workArea.settings.my.saveButton}
                        >
                            {t("Common.save")}
                        </Button>

                        <Button
                            variant="Secondary"
                            onClick={() => setIsCancelModalVisible(true)}
                            disabled={isSubmitting || !isDirty}
                            testId={testIds.workArea.settings.my.cancelButton}
                        >
                            {t("Common.cancel")}
                        </Button>
                    </>
                }
                hideBackArrow
                hideCancelButton
                padding="None"
                className={style.subPageLayout}
            >
                <Box columnLayout paddingTop="Sm" paddingBottom="Sm">
                    <UserSettingsForm setIsSubmitting={setIsSubmitting} setIsDirty={setIsDirty} />
                </Box>
            </SubPageLayout>

            <Modal
                isOpen={isCancelModalVisible}
                hideModal={() => setIsCancelModalVisible(false)}
                title={t("Common.unsavedChanges.title")}
                buttons={
                    <>
                        <Button
                            variant="Primary"
                            onClick={() => setIsCancelModalVisible(false)}
                            testId={testIds.common.dialog.closeButton}
                        >
                            {t("Common.unsavedChanges.keepEditing")}
                        </Button>

                        <Button
                            variant="Secondary"
                            onClick={() => {
                                setFormResetCount((count) => count + 1); // resets form to initial state
                                setIsCancelModalVisible(false);
                            }}
                            testId={testIds.common.confirmationDialog.confirmButton}
                        >
                            {t("Common.unsavedChanges.dontSave")}
                        </Button>
                    </>
                }
            >
                {t("Common.unsavedChanges.warning")}
            </Modal>
        </>
    );
};
